module.exports = __webpack_public_path__ + "static/media/animate-1.00bd05fb.mp4";